module.exports = __webpack_public_path__ + "img/Youtube-icon.8af0ec89.png";